<template>
  <div class="profile-borrower">
    <div v-if="borrower.validated" class="profile-borrower__completed-alert">
      <b-alert v-if="changed" variant="danger" show>
        <h4 class="alert-heading">{{ $t("views.profile.borrower.alerts.warning.title") }}</h4>
        <p>
          {{ $t("views.profile.borrower.alerts.warning.message") }}
        </p>
      </b-alert>
      <b-alert v-else variant="success" show>
        <p>{{ $t("views.profile.borrower.alerts.success.message") }}</p>
      </b-alert>
    </div>
    <div
      v-else-if="borrower.submitted_at && !borrower.suspended"
      class="profile-borrower__completed-alert"
    >
      <b-alert variant="warning" show>
        <p>
          {{ $t("views.profile.borrower.alerts.pending.message") }}
        </p>
      </b-alert>
    </div>

    <b-alert variant="info" show>
      <p>{{ $t("views.profile.borrower.age_requirement") }}</p>
      <p>
        <i18n path="views.profile.borrower.info_requirement">
          <template #privacy_policy>
            <a :href="$t('conditions.privacy_policy_url')" target="_blank">{{
              $t("views.profile.borrower.privacy_policy")
            }}</a>
          </template>
        </i18n>
      </p>
    </b-alert>

    <borrower-form
      :loading="loading"
      :borrower="borrower"
      :changed="changed"
      @reset="reset"
      @save="saveBorrower"
      @submit="submitBorrower"
    />
  </div>
</template>

<script>
import BorrowerForm from "@/components/Borrower/BorrowerForm.vue";
import { put } from "@/requests/server";

export default {
  name: "ProfileBorrower",
  components: { BorrowerForm },
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: "me",
    },
  },
  data() {
    let user = this.$store.state.user;
    return {
      borrower: {
        user_id: user.id,
        ...user.borrower,
      },
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    changed() {
      return JSON.stringify(this.borrower) !== JSON.stringify(this.user.borrower);
    },
  },
  methods: {
    reset() {
      this.borrower = this.$store.state.user.borrower;
    },
    async saveBorrower() {
      this.loading = true;

      const { data: user } = await put(
        `/users/${this.user.id}`,
        { borrower: this.borrower },
        {
          notifications: { action: "Mise à jour du dossier de conduite", onSuccess: true },
          cleanupCallback: () => (this.loading = false),
        }
      );

      this.$store.commit("user", user);
    },
    async submitBorrower() {
      this.loading = true;
      const { data: borrower } = await put(
        `/users/${this.user.id}/borrower/submit`,
        this.borrower,
        {
          notifications: { action: "soumission du dossier de conduite" },
          cleanupCallback: () => (this.loading = false),
        }
      );

      this.$store.commit("user", { ...this.$store.state.user, borrower });

      // send up notification and navigate to dashboard.
      this.$store.commit("addNotification", {
        content: this.$t("views.profile.borrower.notifications.message"),
        title: this.$t("views.profile.borrower.notifications.title"),
        variant: "success",
      });

      this.$router.push("/app");
    },
  },
};
</script>

<style lang="scss">
.profile-borrower {
  &__completed-alert {
    p:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
